// extracted by mini-css-extract-plugin
export default {"file":"File_file__zcHWb","container":"File_container__aKEWe","deleteIcon":"File_deleteIcon__S0jt3"};